<template>
  <div class="handoff">
    <div class="handoff__container">
      <div class="handoff__picture-container">
        <img
          class="handoff__picture-container--img lazy"
          src="/static/images/grid.svg"
          alt="grid"
        >
        <picture class="handoff__preview">
          <source
            media=""
            src="/static/images/handoff.svg"
          >

          <img
            class="lazy"
            data-sizes="auto"
            src="/static/images/handoff.svg"
          >
        </picture>

        <div
          class="handoff__button-video"
          @mouseover="isHovered = true"
          @mouseleave="isHovered = false"
          @click="showVideoModal = !showVideoModal"
        >
          <button-view
            variant="rounded"
          >
            <svg
              class="handoff__play-icon"
              width="60"
              height="69"
              viewBox="0 0 60 69"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M4.12521 64.4578L56.1002 34.4501L4.1252 4.44229L4.12521
                    64.4578ZM57.9002 37.5678C60.3002 36.1821 60.3002 32.718 57.9002
                    31.3324L5.9252 1.32459C3.52521 -0.0610511 0.525204 1.67101 0.525204
                    4.44229L0.525201 64.4578C0.525201 67.2291 3.52521 68.9612 5.92521
                    67.5755L57.9002 37.5678Z"
                fill="white"
              />
            </svg>
          </button-view>

          <p class="handoff__button-text">
            {{ $t('handoff_teaser_button') }}
          </p>
        </div>
      </div>

      <h2 class="handoff__title">
        {{ $t('handoff_title') }}
      </h2>
      <p class="handoff__subtitle">
        {{ $t('handoff_subtitle') }}
      </p>
      <p class="handoff__description">
        {{ $t('handoff_description') }}
      </p>
      <a
        href="https://handoff.blissapplications.com/"
        target="_blank"
      >
        <button class="button button--primary handoff__button">
          {{ $t('handoff_link_button') }}
        </button>
      </a>
    </div>
    <modal-view
      v-if="showVideoModal === true"
      @closeModal="showVideoModal = false;"
    >
      <template #body>
        <div class="modal__video">
          <iframe
            width="560"
            height="315"
            :src="handoffUrl"
            frameborder="0"
            allow="autoplay;"
            title="Handoff – Mini Doc (Trailer)"
          />
        </div>
      </template>
    </modal-view>
  </div>
</template>

<script>

const vimeoUrl = 'https://player.vimeo.com/video/774186728?h=4173e6252e&badge=0&autoplay=1&loop=1&autopause=0&player_id=0&app_id=58479';

export default {
  name: 'HandoffView',

  components: {
    ButtonView: () => import('@/components/button/button-view'),
    ModalView: () => import('@/components/modal/modal-view')
  },

  data() {
    return {
      isHovered: false,
      showVideoModal: false,
      handoffUrl: vimeoUrl
    };
  }
};
</script>

<style lang="scss" src="@/assets/components/handoff/handoff-view.scss"></style>



// WEBPACK FOOTER //
// handoff-view.vue